/**
 * How a drawn body knows which way a block reads, shared by every reader so a
 * paragraph reads the same way in a doc as in a section of the public site.
 */

/**
 * A character that decides a direction, as the browser reads one for
 * `dir="auto"`: a letter, or one of the marks written to decide it.
 */
export const STRONG = /[\p{L}‎‏؜]/u

/**
 * Whether a deciding character reads right to left: a letter of a script
 * written that way, or the mark that says so.
 */
export const RIGHT_TO_LEFT =
  /[‏؜\p{Script=Hebrew}\p{Script=Arabic}\p{Script=Syriac}\p{Script=Thaana}\p{Script=Nko}\p{Script=Samaritan}\p{Script=Mandaic}]/u

/** Whether the character a block reads by is a Hebrew letter. */
export const HEBREW = /\p{Script=Hebrew}/u
